import axios from "axios";
import store from "../store/index.js";
import router from "../router.js";
import { mapApiError } from "./apiErrorMapper.js";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

const AUTH_INVALIDATION_CODES = [
  "errors.auth.invalid_token",
  "errors.auth.expired_token",
  "errors.auth.user_not_found_for_token",
  "errors.auth.password_recently_changed",
];

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const normalized = mapApiError(error);

    if (AUTH_INVALIDATION_CODES.includes(normalized.code) && localStorage.getItem("token")) {
      store.dispatch("auth/logOut");
      if (router.currentRoute.value.name !== "login") {
        router.push("/login");
      }
    }

    try {
      store.dispatch("notifications/showError", normalized);
    } catch {
      // ignore store dispatch errors
    }
    return Promise.reject(normalized);
  }
);

export default http;

